import { ACCOUNTING_MANAGEMENT_TAB } from 'routes/types';

export const DEFAULT_ACCOUNTING_MANAGEMENT_TAB =
  ACCOUNTING_MANAGEMENT_TAB.RECEIVABLES;

export const AccountingManagementTabLabels: Record<
  ACCOUNTING_MANAGEMENT_TAB,
  string
> = Object.freeze({
  [ACCOUNTING_MANAGEMENT_TAB.RECEIVABLES]: 'Số dư đầu kỳ',
  [ACCOUNTING_MANAGEMENT_TAB.SUPPLIERS]: 'Số dư đầu kỳ NCC',
});
